import request from 'services/axios'

const BASE = '/api/v1/web-push'

export const getWebPushConfig = async () => {
    const { data } = await request.get<IWebPushConfig>(`${BASE}/config/`)
    return data
}

export const subscribeWebPush = async (payload: IWebPushSubscribePayload) => {
    const { data } = await request.post(`${BASE}/subscribe/`, payload)
    return data as { subscribed: boolean; prefs: IWebPushPrefs }
}

/**
 * `token` is for logout, which clears localStorage in the same tick that asks
 * for this — the interceptor would find no session by the time it runs.
 */
export const unsubscribeWebPush = async (
    endpoint: string,
    reason: 'unsubscribed' | 'logout' = 'unsubscribed',
    token?: string
) => {
    const { data } = await request.post(
        `${BASE}/unsubscribe/`,
        { endpoint, reason },
        token ? { headers: { Authorization: `JWT ${token}` } } : undefined
    )
    return data as { unsubscribed: boolean }
}

export const updateWebPushPrefs = async (prefs: Partial<IWebPushPrefs>) => {
    const { data } = await request.patch(`${BASE}/prefs/`, prefs)
    return data as IWebPushPrefs
}

/** Push a test notification to this browser (or, without `endpoint`, all of mine). */
export const sendWebPushTest = async (payload: {
    endpoint?: string
    nonce: string
}) => {
    const { data } = await request.post(`${BASE}/test/`, payload)
    return data as IWebPushTestSent
}

export const recordWebPushClick = async (messageId: number) => {
    const { data } = await request.post(`${BASE}/click/`, {
        message_id: messageId,
    })
    return data as { recorded: boolean }
}
